module.exports = __webpack_public_path__ + "fonts/ralewayblackitalic.935a825.woff";